import React, { useState } from 'react'
import { Divider, TextField, Select, DropdownMenuPosition } from '@duik/it'
import EditSiteMap from '../Maps/EditSiteMap'
import { Formik, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import LargeModal from '../../../UI/LargeModal'
import {
  HeadingText,
  HeadingSubText,
  LeftContainer,
  RightContainer,
  ContainerWrapper,
  DriverInstructionTextArea,
  LabelText,
  TextFieldContainer,
  HalfWidthGroup,
  SecondRowContainter,
  InputContainer
} from './styles'

const CreateNewSite = props => {
  const [locationScreen, setLocationScreen] = useState(false)
  const [coordinates, setCoordinates] = useState(
    props.editSiteDetail.coordinates ? props.editSiteDetail.coordinates : {}
  )
  const [customCoordinates, setCustomCoordinates] = useState(
    props.editSiteDetail.customCoordinates ? props.editSiteDetail.customCoordinates : []
  )
  const [radius, setRadius] = useState(0)

  const screenToggle = () => {
    setLocationScreen(!locationScreen)
  }

  const locationCoordinatesEntry = (customCoordinates, siteCenter, radius) => {
    setCoordinates(siteCenter)
    setRadius(radius)
    setCustomCoordinates(customCoordinates)
    screenToggle()
  }

  const editSite = values => {
    const { location, city, province } = props.editSiteDetail
    const { siteName, company, type, project, defaultInstructions } = values
    props.editSite(
      props.editSiteDetail._id,
      siteName,
      company,
      location,
      city,
      province,
      coordinates,
      customCoordinates,
      radius,
      type,
      project,
      defaultInstructions
    )
  }

  return (
    <Formik
      initialValues={{
        siteName: props.editSiteDetail ? props.editSiteDetail.siteName : '',
        company: props.editSiteDetail ? props.editSiteDetail.company : '',
        type: props.editSiteDetail
          ? props.editSiteDetail.type
            ? props.editSiteDetail.type
            : ''
          : '',
        project: props.editSiteDetail
          ? props.editSiteDetail.project
            ? props.editSiteDetail.project.projectName
            : ''
          : '',
        defaultInstructions: props.editSiteDetail
          ? props.editSiteDetail.defaultInstructions
            ? props.editSiteDetail.defaultInstructions
            : ''
          : ''
      }}
      validationSchema={SiteSchema}
      handleSubmit={e => console.log('')}
      onSubmit={values => {
        editSite(values)
      }}
      render={({
        values,
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        touched
      }) => (
        <LargeModal
          handleLinkClick={props.editSiteModalToggle}
          handleSaveButton={handleSubmit}
          title="Edit Site"
          saveButtonText="Save Changes"
        >
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <ContainerWrapper>
                <LeftContainer>
                  <HeadingText>Details</HeadingText>
                </LeftContainer>
                <RightContainer>
                  <InputContainer>
                    <HalfWidthGroup>
                      <TextFieldContainer>
                        <TextField
                          className="newInputBox"
                          label="Site Name"
                          name="siteName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.siteName}
                        />
                        <ErrorMessage
                          name="siteName"
                          render={msg => (
                            <span
                              style={{
                                position: 'absolute',
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg}
                            </span>
                          )}
                        />
                      </TextFieldContainer>
                    </HalfWidthGroup>
                    <HalfWidthGroup>
                      <TextFieldContainer>
                        <TextField
                          className="newInputBox"
                          label="Company"
                          name="company"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.company}
                        />
                        <ErrorMessage
                          name="company"
                          render={msg => (
                            <span
                              style={{
                                position: 'absolute',
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg}
                            </span>
                          )}
                        />
                      </TextFieldContainer>
                    </HalfWidthGroup>
                  </InputContainer>
                  <SecondRowContainter>
                    <HalfWidthGroup>
                      <TextFieldContainer>
                        <Select
                          className="siteSelect optionsFullWidth"
                          activeOption={{
                            value: values.type,
                            label: values.type
                          }}
                          label="Type"
                          name="type"
                          options={[
                            {
                              value: 'Dump',
                              label: 'Dump'
                            },
                            {
                              value: 'Project',
                              label: 'Project'
                            },
                            {
                              value: 'Source',
                              label: 'Source'
                            },
                            {
                              value: 'Transfer',
                              label: 'Transfer'
                            }
                          ]}
                          menuPosition={DropdownMenuPosition['bottom-right']}
                          onOptionClick={e => {
                            if (e.value !== 'Project') {
                              setFieldValue('project', null)
                            }
                            setFieldValue('type', e.value)
                          }}
                        />
                        <ErrorMessage
                          name="type"
                          render={msg => (
                            <span
                              style={{
                                position: 'absolute',
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg}
                            </span>
                          )}
                        />
                      </TextFieldContainer>
                    </HalfWidthGroup>
                    {props.editSiteDetail.project && values.type === 'Project' ? (
                      <HalfWidthGroup>
                        <TextFieldContainer>
                          <Select
                            className="siteSelect"
                            activeOption={
                              props.editSiteDetail.project
                                ? {
                                    value: props.projectList.find(
                                      item => item._id === props.editSiteDetail.project._id
                                    ),
                                    label: props.projectList.find(
                                      item => item._id === props.editSiteDetail.project._id
                                    ).projectName
                                  }
                                : { value: values.project, label: values.project.projectName }
                            }
                            label="Project"
                            name="project"
                            options={[
                              ...props.projectList.map(item => ({
                                value: item,
                                label: item.projectName
                              }))
                            ]}
                            menuPosition={DropdownMenuPosition['bottom-right']}
                            onOptionClick={e => {
                              setFieldValue('project', e.value)
                            }}
                          />
                          <ErrorMessage
                            name="project"
                            render={msg => (
                              <span
                                style={{
                                  position: 'absolute',
                                  color: '#E6492D',
                                  fontSize: '0.75rem'
                                }}
                              >
                                {msg}
                              </span>
                            )}
                          />
                        </TextFieldContainer>
                      </HalfWidthGroup>
                    ) : null}
                  </SecondRowContainter>
                </RightContainer>
              </ContainerWrapper>

              <Divider />
              <ContainerWrapper>
                <LeftContainer>
                  <HeadingText>Driver Instructions</HeadingText>
                  <HeadingSubText>These will be sent when dispatching trucks</HeadingSubText>
                </LeftContainer>
                <RightContainer>
                  <div>
                    <LabelText>Default</LabelText>
                    <DriverInstructionTextArea
                      name="defaultInstructions"
                      value={values.defaultInstructions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                </RightContainer>
              </ContainerWrapper>

              <Divider />
              <ContainerWrapper>
                <LeftContainer>
                  <HeadingText>Geo-fence</HeadingText>
                  <HeadingSubText>
                    {props.editSiteDetail.customCoordinates &&
                    props.editSiteDetail.customCoordinates.length > 0
                      ? 'Draw the perimeter of the site'
                      : 'Contact support to update this site to a geo-fence'}
                  </HeadingSubText>
                </LeftContainer>
                <RightContainer>
                  <EditSiteMap
                    screenToggle={screenToggle}
                    locationCoordinatesEntry={locationCoordinatesEntry}
                    editSiteDetail={props.editSiteDetail}
                  />
                </RightContainer>
              </ContainerWrapper>
            </div>
          </form>
        </LargeModal>
      )}
    />
  )
}

export default CreateNewSite

const SiteSchema = Yup.object().shape({
  siteName: Yup.string()
    .min(2, 'Too Short!')
    .max(30, 'Too Long!')
    .required('Required'),
  company: Yup.string()
    .min(2, 'Too Short!')
    .max(30, 'Too Long!')
    .required('Required')
})
